import { useEffect, useState } from 'react';
import { RootState } from '@/store/index';
import { useDispatch, useSelector } from 'react-redux';
import { setProfile } from '@/store/slices/profile/profileSlice';
import { setComments } from '@/store/slices/comments/commentsSlice';
import { getPrivateVideoCommentsApiCall, getPublicVideoCommentsApiCall, getUserProfileApiCall } from "@/services/api"

import VideoCommentsView from "./view";
import { useAuthToken } from '@/hooks/useAppSelectors';
import { sanitizeUrlsForBudketOldLinks } from '@/utils';
import { oldS3BucketLink } from '@/constants/apiPaths';

export default function VideoComments(props: any) {
    const token = useAuthToken()
    const dispatch = useDispatch();
    const videoDetails = useSelector((state: RootState) => state.videoReducer.video);
    const profileDetails = useSelector((state: RootState) => state.profileReducer.profile);
    const allComments = useSelector((state: RootState) => state.commentsReducer.comments);
    const screenWidth = useSelector((state: RootState) => state.screenWidthReducer.screenWidth);
    const [currentLoadingStage, setCurrentLoadingStage] = useState(0)
    const [commentIsLoading, setCommentIsLoading] = useState(false)
    const [finalIsLoading, setfinalIsLoading] = useState(true)


    useEffect(() => {
        initPage()
    }, [videoDetails])


    useEffect(() => {
        if (currentLoadingStage === 2) {
            setCommentIsLoading(false)
        } else {
            setCommentIsLoading(true)
        }
    }, [currentLoadingStage])

    useEffect(() => {
        if (!props.isLoading && !commentIsLoading) {
            setfinalIsLoading(false)
        }
    }, [commentIsLoading])


    const initPage = () => {
        setfinalIsLoading(true)
        setCurrentLoadingStage(0)
        if (token) {
            getProfile()
        }
        getComments()
    }

    const getProfile = async () => {
        if (Object.entries(profileDetails).length === 0) {
            const profileDetails = await getUserProfileApiCall();
            if (profileDetails.data && profileDetails.status) {
                const sanitizedProfileDetails = sanitizeUrlsForBudketOldLinks(profileDetails.data, oldS3BucketLink)
                dispatch(setProfile(sanitizedProfileDetails));
                // console.log(profileDetails.data)
            }
        }
        setCurrentLoadingStage((prev) => prev + 1);
    }



    const getComments = async () => {
        if (videoDetails && videoDetails._id) {
            const videoDocId = videoDetails._id
            // const isPublic = videoDetails.isPublictoken
            let getVideoCommentsApiCallStatus = null
            if (token) {
                getVideoCommentsApiCallStatus = await getPrivateVideoCommentsApiCall(videoDocId)
            } else {
                getVideoCommentsApiCallStatus = await getPublicVideoCommentsApiCall(videoDocId)
            }

            if (getVideoCommentsApiCallStatus
                && getVideoCommentsApiCallStatus.success || getVideoCommentsApiCallStatus.status) {
                dispatch(setComments(getVideoCommentsApiCallStatus.data.comments));
            }
            else {
                console.log(getVideoCommentsApiCallStatus)
            }
        }
        setCurrentLoadingStage((prev) => prev + 1);
    }

    return (
        <>
            <VideoCommentsView
                commentIsLoading={commentIsLoading}
                screenWidth={screenWidth}
                finalIsLoading={finalIsLoading}
            />
        </>
    );
}

